require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./inherited-widget-custom-theme-class.json") })
        }
      }, "path---inherited-widget-custom-theme-class");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---inherited-widget-custom-theme-class!./.cache/json/inherited-widget-custom-theme-class.json
// module id = 393
// module chunks = 231608221292675